





















import { Vue, Component, Prop } from "vue-property-decorator";
import { Route } from "vue-router";
import useMatomoEvent from "@/composition/useMatomoEvent";

@Component({
  setup() {
    return { useMatomoEvent };
  }
})
export default class CdkNavigationItem extends Vue {
  @Prop({ required: true }) route!: Route;

  @Prop({ required: true }) icon!: String;

  @Prop({ required: true }) label!: String;

  @Prop({ required: false }) matomoEvent?: any;
}
